<template>
  <!-- The design's own star — Figma "Star 50" (426:257 / 421:1216 / 421:1229),
       exported as-is. Its stroked box is 22.566×21.6099 and Figma insets it
       0.9%/2.99%/9.06%/2.99% in a 24×24 slot — i.e. it hangs ~1px ABOVE the
       middle, which is the optical correction a five-pointed star needs next to
       a digit. Keep that inset; centring the box makes it read as sitting low. -->
  <svg
    class="star-icon"
    :width="size"
    :height="size"
    viewBox="-0.718 -0.216 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M10.8047 1.35438C10.9485 0.881874 11.6175 0.881874 11.7613 1.35438L13.7475 7.87839C13.8126 8.09221 14.0117 8.23685 14.2351 8.23268L21.0536 8.10561C21.5474 8.09641 21.7541 8.73262 21.3492 9.01544L15.7583 12.9204C15.575 13.0484 15.499 13.2825 15.572 13.4937L17.7999 19.9392C17.9612 20.406 17.4201 20.7992 17.0259 20.5015L11.5844 16.3909C11.406 16.2562 11.16 16.2562 10.9816 16.3909L5.54005 20.5015C5.14594 20.7992 4.60475 20.406 4.76611 19.9392L6.99398 13.4937C7.06699 13.2825 6.99095 13.0484 6.80772 12.9204L1.21677 9.01544C0.811846 8.73262 1.01856 8.09641 1.51239 8.10561L8.33086 8.23268C8.55432 8.23685 8.75341 8.09221 8.8185 7.87839L10.8047 1.35438Z"
      :fill="filled ? 'currentColor' : 'none'"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>
</template>

<script setup>
defineProps({
  size: { type: [Number, String], default: 22 },
  filled: { type: Boolean, default: true },
})
</script>

<style scoped>
.star-icon {
  display: block;
}
</style>
